import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import "bootstrap/dist/js/bootstrap.bundle.js"
import 'material-icons/iconfont/material-icons.css';
import './StyleSheets/custom-css.scss';
import store from './store';

createApp(App).use(router).use(store).mount('#app')
